/**
 * Splide has been just created.
 */
export const CREATED = 1;

/**
 * Splide has mounted components.
 */
export const MOUNTED = 2;

/**
 * Splide is ready.
 */
export const IDLE = 3;

/**
 * Splide is moving.
 */
export const MOVING = 4;

/**
 * Splide has been destroyed.
 */
export const DESTROYED = 5;

/**
 * The collection of all states.
 *
 * @since 3.0.0
 */
export const STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  DESTROYED,
};
